import { packMode, numOr, priceText, pcsText } from '../lib/stockMath.js';

// The conversion the server will do, printed under the box it applies to. The
// box itself is never touched: it keeps whatever was typed, in whatever order
// the form was filled in, and `stock_qty_type` travels with it so the maths
// happens once, on save.
// Nothing is shown for a piece-only product — there the box already holds the
// stored figure, so the line would only repeat it.
const SaveHint = ({ value, unitsPerPack, kind, t }) => {
  if (!packMode(unitsPerPack)) return null;
  const n = numOr(value, NaN);
  if (!Number.isFinite(n)) return null;
  let text;
  if (kind === 'price') {
    text = 'Rs. ' + priceText(n / numOr(unitsPerPack, 1)) + ' / ' + t('piece');
  } else {
    // Rounded exactly as the server rounds it: 6.67 packs of 12 is 80 pieces,
    // never 84.
    const pieces = Math.round(n * numOr(unitsPerPack, 1));
    text = t('total') + ': ' + pcsText(pieces) + ' '
      + (pieces === 1 ? t('piece') : t('pieces'));
  }
  return (
    <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: '4px' }}>{text}</div>
  );
};

export { SaveHint };
